import styled from 'styled-components'

export const StyledDivision = styled.div`
  text-align: center;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
`
export const NumberDiv = styled.div`
  padding-top: 10px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 35px;
`
export const MainDiv = styled.div`
  border: #d8ddff 2px solid;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
`
export const StudentDiv = styled.div`
  font-size: 20px;
`
export const MainQualificationDiv = styled.div`
  border: 2px solid rgb(216, 221, 255);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;

  padding-left: 20px;
  padding-right: 20px;

  height: 25em;
  margin-top: 1em;
  overflow-y: auto;
`
export const Chips = styled.div`
  border: 1px solid #3249d7;
  border-radius: 14px;
  font-size: 10px;
  color: #000000;
  padding: 1px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
`
